import { FunctionComponent } from "react";

interface RequiredMarkProps {}

const RequiredMark: FunctionComponent<RequiredMarkProps> = () => {
  return <span className="text-red-400 text-lg">*</span>;
};

export default RequiredMark;
